/* eslint-disable i18next/no-literal-string -- type definitions */
export const ReportCategoryType = {
    GLOBAL: 'GLOBAL',
    PERSONAL: 'PERSONAL',
} as const
export type ReportCategoryType = typeof ReportCategoryType[keyof typeof ReportCategoryType]
/* eslint-enable i18next/no-literal-string */
